import { render, staticRenderFns } from "./htfbmenu.vue?vue&type=template&id=38038189&scoped=true&"
import script from "./htfbmenu.vue?vue&type=script&lang=js&"
export * from "./htfbmenu.vue?vue&type=script&lang=js&"
import style0 from "./htfbmenu.vue?vue&type=style&index=0&id=38038189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38038189",
  null
  
)

export default component.exports